// The type for a single customer data
import { useSearch } from "../useSearch";
import { ICustomer } from "../../@types";
import { projectService } from "../../services/projectService";

export const useProjectSearch = () => {
  return useSearch({
    service: projectService,
    endpoint: "project/search",
    queryParameter: "q",
    responseMapper: (data: any[]): any =>
      data.map((cu: any) => ({
        ...cu,
        id: cu.id,
        name: `${cu.firstName} ${cu.lastName}`,
      })) as unknown as ICustomer,
  });
};
